module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "4fr 1fr",
      "gap": "1rem",
      "align-items": "start"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-wr u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Producto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Warehouse")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Acciones")])]), _vm._v(" "), _vm._l((_vm.warehouseorder), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-wr"
    }, [_c('div', [_c('article', {
      staticClass: "card-product"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [(data.attributes.product_image_url) ? _c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": data.attributes.product_image_url
      }
    }) : _c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": "https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.product_info))]), _vm._v(" "), (data.attributes.reference_link) ? _c('a', {
      attrs: {
        "href": data.attributes.reference_link,
        "target": "_Blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Nombres:")]), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.name) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.surnames) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código del cliente:")]), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.userable
      .client_code) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                        " + _vm._s(data.attributes.system_tracking_number) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje desde:")]), _vm._v("\n                        " + _vm._s(data.attributes.origin.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje a:")]), _vm._v("\n                        " + _vm._s(data.attributes.destination.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Número de orden:")]), _vm._v("\n                        #" + _vm._s(data.id) + "\n                      ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-width": "38vw"
      }
    }, [
      [_c('vue-glide', {
        attrs: {
          "perView": 2
        }
      }, [_vm._l((data.attributes.warehouse_packages), function(wr) {
        return _c('vue-glide-slide', {
          key: wr
        }, [_c('article', {
          staticClass: "card-product"
        }, [_c('div', {
          staticClass: "card-product__text"
        }, [_c('h3', {
          staticClass: "card-product__title"
        }, [_c('span', [_vm._v("#" + _vm._s(wr.attributes.code) + "-\n                              "), _c('a', {
          staticStyle: {
            "cursor": "pointer",
            "color": "blue"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.liberarWR(wr.attributes.code)
            }
          }
        }, [_vm._v("\n                                Liberar\n                              ")])]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fas fa-link"
        })])]), _vm._v(" "), _c('div', {
          staticClass: "card-product__info"
        }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              " + _vm._s(wr.attributes.remitter ?
          wr.attributes.remitter :
          "Sin remitente") + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              " + _vm._s(wr.attributes.consignee) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              " + _vm._s(wr.attributes.remitter) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              " + _vm._s(wr.attributes.carrier) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              " + _vm._s(wr.attributes.weight) + "\n                              "), _c('b', [_vm._v("\n                                " + _vm._s(wr.attributes.weight_unit.attributes.key_name))])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              " + _vm._s(wr.attributes.comment) + "\n                            ")]), _vm._v(" "), (wr.attributes.images) ? _c('a', {
          staticStyle: {
            "color": "#1ea9e4",
            "font-weight": "600"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.openModal('modal-fotos', null, wr.attributes.images)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-link mr-2"
        }), _vm._v("\n                              Ver fotos\n                            ")]) : _vm._e()])])])])
      }), _vm._v(" "), _c('template', {
        slot: "control"
      }, [_c('button', {
        staticClass: "slider__btn slider__btn--prev",
        attrs: {
          "data-glide-dir": "<"
        }
      }, [_c('i', {
        staticClass: "fas fa-arrow-left"
      })]), _vm._v(" "), _c('button', {
        staticClass: "slider__btn slider__btn--next",
        attrs: {
          "data-glide-dir": ">"
        }
      }, [_c('i', {
        staticClass: "fas fa-arrow-right"
      })])])], 2)]
    ], 2), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary mb-3 d-block mx-auto",
      attrs: {
        "disabled": data.attributes.warehouse_flag == 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-wr', data.id)
        }
      }
    }, [_vm._v("\n                  Registrar ingreso\n                ")]), _vm._v(" "), (data.attributes.warehouse_packages.length !== 0) ? _c('button', {
      staticClass: "btn d-block mx-auto",
      class: data.attributes.warehouse_flag == 0 ? 'btn-primary' : 'btn-success',
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.limitchangePaquete(data.id)
        }
      }
    }, [(data.attributes.warehouse_flag !== 0) ? _c('i', {
      staticClass: "fas fa-check pr-2 pt-1"
    }) : _vm._e(), _vm._v("\n                  " + _vm._s(data.attributes.warehouse_flag == 0 ?
      "Items incompletos" :
      "Items completos") + "\n                ")]) : _vm._e()])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wr-slider-vertical"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-wr')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n          Nuevo paquete\n        ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.wrSinAsignar), function(data) {
    return _c('article', {
      key: data,
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.code))]), _vm._v(" -\n            "), _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "grab"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteWR(data)
        }
      }
    }, [_vm._v("Eliminar")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.copyCodeWr(data.attributes.code)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              " + _vm._s(data.attributes.remitter ? data.attributes.remitter : "Sin remitente") + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              " + _vm._s(data.attributes.consignee) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              " + _vm._s(data.attributes.remitter) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              " + _vm._s(data.attributes.carrier) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              " + _vm._s(data.attributes.weight) + "\n              "), _c('b', [_vm._v(" " + _vm._s(data.attributes.weight_unit.attributes.key_name))])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              " + _vm._s(data.attributes.comment) + "\n            ")]), _vm._v(" "), (data.attributes.images) ? _c('a', {
      staticStyle: {
        "color": "#1ea9e4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos', null, data.attributes.images)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n              Ver fotos\n            ")]) : _vm._e()])])])
  })], 2)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrders
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-fotos"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "70vw",
      "width": "70vw"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Fotos del producto")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-fotos')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr",
      "gap": "1rem"
    }
  }, _vm._l((_vm.wrFotos), function(image) {
    return _c('img', {
      key: image,
      staticClass: "product-image",
      attrs: {
        "src": image.url,
        "alt": ""
      }
    })
  }), 0)])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-wr"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Datos del paquete")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-wr')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remitente :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.remitter),
      expression: "formCreate.remitter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.remitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "remitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Destinatario :(Consignatario)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Carrier :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Tracking :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Peso :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unidad de peso :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentario :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fotos del paquete :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Warehouse")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42cf38cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WarehouseTable.vue
// module id = 1872
// module chunks = 1